import Vue from 'vue';

export interface StoreValues {
  // To be declared by the App
}

export default class Store {
  private readonly callers: Array<string> = [];
  private readonly internalValues: StoreValues = Vue.observable({} as StoreValues);
  get values(): StoreValues {
    if (process.env!.VUE_APP_BUILD_CONFIGURATION === 'development') {
      const err = new Error();
      this.callers.unshift(err.stack ?? '');
      if (this.callers.length > 10) {
        this.callers.pop();
      }
    }
    return this.internalValues;
  }
}
